<div class="header">
  <div class="slide-number">{{ questionNumber }}</div>
  <div class="flexibility" [ngClass]="question.flexibility">{{ question.flexibility }}</div>
</div>
<div class="question">{{ question.questionWording }}</div>
@if (question.answerType === 'long-text') {
  <app-ssqw-long-text-form
    [initial]="initialValue"
    [required]="question.flexibility === 'required'"
    [clearEvent]="clearEmitter"
    (status)="onStatusChange($event)"
  (inputClicked)="inputClicked.emit($event)"></app-ssqw-long-text-form>
}
@if (question.answerType === 'short-text') {
  <app-ssqw-input-form
    type="text"
    [initial]="initialValue"
    [required]="question.flexibility === 'required'"
    [clearEvent]="clearEmitter"
    (status)="onStatusChange($event)"
  (inputClicked)="inputClicked.emit($event)"></app-ssqw-input-form>
}
@if (question.answerType === 'email') {
  <app-ssqw-input-form
    type="email"
    [initial]="initialValue"
    [required]="question.flexibility === 'required'"
    [clearEvent]="clearEmitter"
    (status)="onStatusChange($event)"
  (inputClicked)="inputClicked.emit($event)"></app-ssqw-input-form>
}
@if (question.answerType === 'date') {
  <app-ssqw-input-form
    type="date"
    [initial]="initialValue"
    [required]="question.flexibility === 'required'"
    [clearEvent]="clearEmitter"
  (status)="onStatusChange($event)"></app-ssqw-input-form>
}
@if (question.answerType === 'number') {
  <app-ssqw-input-form
    type="number"
    [initial]="initialValue"
    [required]="question.flexibility === 'required'"
    [clearEvent]="clearEmitter"
    (status)="onStatusChange($event)"
  (inputClicked)="inputClicked.emit($event)"></app-ssqw-input-form>
}
@if (question.answerType === 'phone') {
  <app-ssqw-input-form
    type="tel"
    [initial]="initialValue"
    [required]="question.flexibility === 'required'"
    [clearEvent]="clearEmitter"
    (status)="onStatusChange($event)"
  (inputClicked)="inputClicked.emit($event)"></app-ssqw-input-form>
}
@if (question.answerType === 'multiple-choice' && !question.options.isMultiSelect) {
  <app-ssqw-radio-form
    [options]="question.options.answerOptions"
    [allowOther]="question.options.hasOther"
    [initial]="initialValue"
    [required]="question.flexibility === 'required'"
    [clearEvent]="clearEmitter"
    (status)="onStatusChange($event)"
  (inputClicked)="inputClicked.emit($event)"></app-ssqw-radio-form>
}
@if (question.answerType === 'yes-no') {
  <app-ssqw-radio-form
    [options]="['Yes', 'No']"
    [allowOther]="false"
    [initial]="initialValue"
    [required]="question.flexibility === 'required'"
    [clearEvent]="clearEmitter"
  (status)="onStatusChange($event)"></app-ssqw-radio-form>
}
@if (question.answerType === 'multiple-choice' && question.options.isMultiSelect) {
  <app-ssqw-checkbox-form
    [options]="question.options.answerOptions"
    [allowOther]="question.options.hasOther"
    [initial]="initialValue"
    [required]="question.flexibility === 'required'"
    [clearEvent]="clearEmitter"
    (status)="onStatusChange($event)"
  (inputClicked)="inputClicked.emit($event)"></app-ssqw-checkbox-form>
}
<ion-row class="ion-justify-content-center">
  <ion-button [disabled]="disableOk" class="ok submitButton" color="secondary" (click)="ok.emit()">OK</ion-button>
</ion-row>
<ion-row class="ion-justify-content-center">
  @if (showClear) {
    <ion-button class="clear secondaryTextLink" type="button" fill="clear" (click)="onClear()">
      CLEAR RESPONSE
    </ion-button>
  }
</ion-row>
